import { RefObject, useEffect, useState } from 'react';

export const useScrollPosition = (container: RefObject<HTMLElement | null>) => {
  const [scrollPosition, setPosition] = useState<{ scrollX: number; scrollY: number }>({ scrollX: 0, scrollY: 0 });

  useEffect(() => {
    const element = container.current;
    if (!element) return;

    let rafId = 0;
    let lastX = element.scrollLeft;
    let lastY = element.scrollTop;

    const commit = () => {
      rafId = 0;
      const x = element.scrollLeft;
      const y = element.scrollTop;
      if (x === lastX && y === lastY) return;
      lastX = x;
      lastY = y;
      setPosition({ scrollX: x, scrollY: y });
    };

    const onScroll = () => {
      if (rafId === 0) rafId = requestAnimationFrame(commit);
    };

    element.addEventListener('scroll', onScroll, { passive: true });
    setPosition({ scrollX: lastX, scrollY: lastY });

    return () => {
      element.removeEventListener('scroll', onScroll);
      if (rafId !== 0) cancelAnimationFrame(rafId);
    };
  }, [container]);

  return scrollPosition;
};
